module.exports = __webpack_public_path__ + "img/678E67_C4D9C4_ACC8AC_98B898-256px.36a724e9.png";